import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito saber inglés para usar esto?',
    a: 'No. El pack está diseñado específicamente para el argentino que no sabe inglés o sabe muy poco. Todo viene con fonética criolla para pronunciar sin haber estudiado nunca.'
  }, {
    q: '¿Cómo recibo el material?',
    a: '100% digital. En menos de 5 minutos después de la compra recibís acceso inmediato a todos los PDFs para descargar y guardar en tu celular, tablet o computadora.'
  }, {
    q: '¿Sirve para cualquier ciudad del Reino Unido o solo para Londres?',
    a: 'El pack está centrado en Londres pero las frases, vocabulario y situaciones de emergencia aplican a cualquier ciudad del Reino Unido. La guía Expert está focalizada en Londres.'
  }, {
    q: '¿Puedo imprimirlo?',
    a: 'Sí. Todos los PDFs están optimizados para imprimir. Podés llevarlo en papel si preferís no depender del celular.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días completos. Si no es lo que esperabas te devolvemos el 100% del dinero sin preguntas ni formularios.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-900" data-id="element-94">
      <div className="max-w-3xl mx-auto" data-id="element-95">
        <div className="text-center mb-12" data-id="element-96">
          <motion.div initial={{
          scale: 0.8,
          opacity: 0
        }} whileInView={{
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-500/20 text-blue-400 mb-6" data-id="element-97">
            <HelpCircle className="w-8 h-8" data-id="element-98" />
          </motion.div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-99">
            LO QUE MÁS NOS PREGUNTAN
          </h2>
        </div>

        <div className="space-y-4" data-id="element-100">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="glass-panel rounded-2xl overflow-hidden border-slate-700/50" data-id="element-101">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full text-left p-6 flex items-center justify-between gap-4 focus:outline-none" data-id="element-102">
                <span className="font-bold text-lg text-white" data-id="element-103">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-slate-400 shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-104" />
              </button>

              <AnimatePresence data-id="element-105">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-106">
                    <div className="px-6 pb-6 pt-0 text-slate-300 leading-relaxed" data-id="element-107">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}